import React from 'react';
import { HealthInsurance } from '../components/health-insurance.component';
import Header from '../components/header.component';
import { Footer } from '../components/footer.component';
import { useSelector } from 'react-redux';
// import '../scss/main.scss';
import SectionHeader from '../components/common';
import { useTranslation } from 'react-i18next';
import FreelancerCtaSection from '../components/freelancer-call-to-action';
import { InvozioAsFreelancer } from '../components/images/png/icons';
import '../scss/freelance-life.style.scss';
import SEOMetadataComponent from '../components/seo-metadata.component';
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from '../../common/FunctionUtils';

interface RootState {
    auth: {
        user: string | null;
    };
}

interface HealthInsurancePageProps {
    dashboardFooter?: boolean;
}

export const HealthInsurancePage: React.FC<HealthInsurancePageProps> = ({ dashboardFooter }) => {
    const user = useSelector((state: RootState) => state.auth.user);
   const { t, i18n } = useTranslation();
      const currentLanguage = i18n.language;
  
      const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
      const canonicalUrl = isEnglish
          ? `https://www.invozio.com/health-insurance-main?lang=${LOCALES.EN_US}`
          : `https://www.invozio.com/sjukforsakring-huvud?lang=${LOCALES.SV_SE}`;


      const schemaMarkup = getSchemaMarkup("sjukforsakring-huvud");

    return (

        <>
            <Header/>
            <SEOMetadataComponent
                title={t('HEALTH_INSURANCE')}
                // description={t('FEATURES_MAIN_DESCRIPTION')}
                canonicalUrl={canonicalUrl}
                noindex={false}
                robots="index, follow"
                schemaMarkup={schemaMarkup}
            />
            <SectionHeader
                titleKey={t('HEALTH_INSURANCE')}
                className="invozio-news-section"
                titleClassName="main-title"
                subtitleClassName="sub-title"
                alignment="center"
            />
            <HealthInsurance />
           
               <FreelancerCtaSection
                title={t('LET_INVOZIO_HELP_YOU_AS_FREELANCER')}
                description={[t('FREELANCING_REWARDING_CAREER_TEXT_1'), t('FREELANCING_REWARDING_CAREER_TEXT_2')]}
                buttonText={t('CREATE_FREE_ACCOUNT')}
                imageSrc={InvozioAsFreelancer}
                imageAlt="Freelancer illustration"
            />
          

            <Footer />
        </>

    );
};

export default HealthInsurancePage;
